import React, { useEffect, useState } from "react";
import { CircularProgress, makeStyles, Typography } from "@material-ui/core";
import { useParams } from "react-router-dom";

import MainContainer from "../../components/MainContainer";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
  embedShell: {
    display: "flex",
    height: "calc(100vh - 48px)",
    overflow: "hidden",
    width: "100%"
  },
  iframe: {
    border: 0,
    flex: 1,
    height: "100%",
    width: "100%"
  },
  empty: {
    alignItems: "center",
    color: theme.palette.text.secondary,
    display: "flex",
    flex: 1,
    justifyContent: "center",
    padding: theme.spacing(3),
    textAlign: "center"
  }
}));

const MenuEmbed = () => {
  const classes = useStyles();
  const { itemId } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const fetchItem = async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/account-menu");
        const nextItem = (data.items || []).find(menuItem => String(menuItem.id) === String(itemId));
        if (mounted) setItem(nextItem || null);
      } catch (err) {
        toastError(err);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchItem();

    return () => {
      mounted = false;
    };
  }, [itemId]);

  const canEmbed = item?.type === "embed" && item?.url && item?.isActive !== false;

  return (
    <MainContainer>
      <div className={classes.embedShell}>
        {loading && (
          <div className={classes.empty}>
            <CircularProgress size={28} />
          </div>
        )}
        {!loading && canEmbed && (
          <iframe className={classes.iframe} src={item.url} title={item.label} />
        )}
        {!loading && !canEmbed && (
          <div className={classes.empty}>
            <Typography>No se encontró un embebido activo para mostrar.</Typography>
          </div>
        )}
      </div>
    </MainContainer>
  );
};

export default MenuEmbed;
